import React from 'react';

import LockedLeadCaptureForm from '@components/LockedLeadCaptureForm';
import MarketingLeadCaptureWithApple from '@components/LockedLeadCaptureForm/MarketingLeadCaptureWithApple';
import MarketingLeadCaptureWithGoogle from '@components/LockedLeadCaptureForm/MarketingLeadCaptureWithGoogle';
import { create_lead_with_oauth_path, create_user_path } from '@routes';
import { READER_URL } from '@src/env';

import marketingModalStyles from '../Layout/styles.module.scss';

const LeadCaptureModalBody = ({
  buttonText,
  disclosure,
  isGdprLead,
  leadType,
  offerLink,
  trackingProps,
}: {
  buttonText: string;
  disclosure?: string;
  isGdprLead?: boolean;
  leadType: string;
  offerLink: string;
  trackingProps?: { [key: string]: string };
}) => {
  const returningUri = `${READER_URL}/${offerLink}`;

  return (
    <div>
      <div className={marketingModalStyles.offerAction}>
        <div className="lead-form-capture">
          <LockedLeadCaptureForm
            buttonText={buttonText}
            colorScheme="light"
            emailPlaceholderText="your email address"
            endpointUri={create_user_path()}
            formLocation="marketing_modal"
            isGdprLead={isGdprLead}
            leadType={leadType}
            redirectUri={offerLink}
            trackingProps={{ ...trackingProps, name: 'subscribe' }}
          />
        </div>
        <p className="type mb1 mt1">- or -</p>
        <div className="flex flex-col items-center">
          <MarketingLeadCaptureWithGoogle
            formLocation="marketing_modal"
            eventName="createLeadWithGoogle"
            verificationUri={create_lead_with_oauth_path()}
            leadType={leadType}
            returningUri={returningUri}
          />
        </div>
        <div className="mt-8 flex flex-col items-center">
          <MarketingLeadCaptureWithApple
            formLocation="marketing_modal"
            eventName="createLeadWithApple"
            verificationUri={create_lead_with_oauth_path()}
            leadType={leadType}
            returningUri={returningUri}
          />
        </div>
      </div>
      <div className={marketingModalStyles.disclosure}>{disclosure}</div>
    </div>
  );
};

export default LeadCaptureModalBody;
